<template>
  <v-card class="statistics-card elevation-0">
    <v-card-title class="align-start pb-2 px-6 pt-5">
      <span class="text-subtitle-1 font-weight-bold dark-blue-text">{{ $t("Statistics Overview") || 'Statistics Overview' }}</span>
    </v-card-title>

    <v-card-text class="px-6 pb-6">
      <v-row>
        <v-col
          v-for="data in allCounts"
          :key="data.title"
          cols="6"
          sm="4"
          md="2"
          class="py-2"
        >
          <div
            class="stat-item d-flex align-center pa-3 cursor-pointer hover-stat-item transition-all"
            @click="navigateToRoute(data.title)"
          >
            <v-avatar
              size="48"
              :color="resolveStatisticsIconVariation(data.title).bg"
              class="stat-avatar me-3"
            >
              <v-icon
                size="24"
                :color="resolveStatisticsIconVariation(data.title).color"
              >
                {{ resolveStatisticsIconVariation(data.title).icon }}
              </v-icon>
            </v-avatar>
            <div>
              <p class="text-xs mb-0 grey-text text-uppercase font-weight-semibold">
                {{ $t(data.title) || data.title }}
              </p>
              <h3 class="text-h6 font-weight-bold dark-blue-text mt-n1">
                {{ data.total || 0 }}
              </h3>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    allCounts: { type: Array, default: () => [] },
  },
  methods: {
    resolveStatisticsIconVariation (title) {
      switch (title) {
        case 'Drivers':
          return {
            icon: 'mdi-account-tie-hat',
            color: '#10B981', // green
            bg: 'rgba(16, 185, 129, 0.12)',
          }
        case 'Customers':
          return {
            icon: 'mdi-account-group',
            color: '#8B5CF6', // purple
            bg: 'rgba(139, 92, 246, 0.12)',
          }
        case 'Reservations':
          return {
            icon: 'mdi-poll',
            color: '#3B82F6', // blue
            bg: 'rgba(59, 130, 246, 0.12)',
          }
        case 'Trips':
          return {
            icon: 'mdi-bus-clock',
            color: '#F59E0B', // gold/orange
            bg: 'rgba(245, 158, 11, 0.12)',
          }
        case 'Routes':
          return {
            icon: 'mdi-road-variant',
            color: '#EF4444', // red
            bg: 'rgba(239, 68, 68, 0.12)',
          }
        case 'Stops':
          return {
            icon: 'mdi-bus-stop',
            color: '#14B8A6', // teal
            bg: 'rgba(20, 184, 166, 0.12)',
          }
        default:
          return {
            icon: 'mdi-account',
            color: '#082C69',
            bg: 'rgba(8, 44, 105, 0.12)',
          }
      }
    },
    navigateToRoute(title) {
      const routeMap = {
        'Reservations': 'reservations',
        'Customers': 'customers',
        'Drivers': 'drivers',
        'Routes': 'routes',
        'Stops': 'stops',
        'Trips': 'trips',
      };
      const name = routeMap[title];
      if (name) {
        this.$router.push({ name }).catch(() => {});
      }
    },
  },
}
</script>

<style scoped>
.statistics-card {
  background-color: #FFFFFF !important;
  border-radius: 12px !important;
  border: 1px solid #E4E8F0 !important;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.02) !important;
}

.stat-item {
  border-radius: 10px;
  background-color: #F8FAFC;
  border: 1px solid #F1F5F9;
  transition: all 0.2s ease;
}

.stat-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.04);
  background-color: #FFFFFF;
}

.stat-avatar {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.02);
}

.dark-blue-text {
  color: #061B40 !important;
}

.grey-text {
  color: #64748B !important;
  font-size: var(--dashboard-small-font-size) !important;
  letter-spacing: normal;
}
</style>
